import { useEffect, useState } from 'react';
/**
 * Inspired from beautiful-hooks
 * source: https://github.com/antonioru/beautiful-react-hooks/blob/master/src/useMediaQuery.ts
 *
 * Accepts a media query string then uses the
 * [window.matchMedia](https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia) API to determine if it
 * matches with the current document.
 */
export const useMediaQuery = (query) => {
    var _a;
    const mediaQuery = query.replace(/^@media( ?)/m, '');
    const matchMedia = (mediaQuery) => {
        return typeof window !== 'undefined' && (window === null || window === void 0 ? void 0 : window.matchMedia) ? window.matchMedia(mediaQuery) : undefined;
    };
    const [isVerified, setIsVerified] = useState(!!((_a = matchMedia(mediaQuery)) === null || _a === void 0 ? void 0 : _a.matches));
    useEffect(() => {
        const mediaQueryList = matchMedia(mediaQuery);
        const documentChangeHandler = () => {
            setIsVerified(!!(mediaQueryList === null || mediaQueryList === void 0 ? void 0 : mediaQueryList.matches));
        };
        try {
            mediaQueryList === null || mediaQueryList === void 0 ? void 0 : mediaQueryList.addEventListener('change', documentChangeHandler);
        }
        catch (_a) {
            // Safari isn't supporting mediaQueryList.addEventListener
            mediaQueryList === null || mediaQueryList === void 0 ? void 0 : mediaQueryList.addListener(documentChangeHandler);
        }
        documentChangeHandler();
        return () => {
            try {
                mediaQueryList === null || mediaQueryList === void 0 ? void 0 : mediaQueryList.removeEventListener('change', documentChangeHandler);
            }
            catch (_a) {
                // Safari isn't supporting mediaQueryList.removeEventListener
                mediaQueryList === null || mediaQueryList === void 0 ? void 0 : mediaQueryList.removeListener(documentChangeHandler);
            }
        };
    }, [mediaQuery]);
    return isVerified;
};
